import React,{ useState, useRef, useEffect } from 'react';
import { Tab, Nav} from 'react-bootstrap';
import AllNotification from "../../../components/Notifications/AllNotification";
import ScheduledNotificationsList from "../../../components/Notifications/ScheduledNotificationsList";

const ACTIVE_TAB_STORAGE_KEY = 'notificationOverviewActiveTab';

const NotificationOverview = () =>{
    const [data, setData] = useState(
        document.querySelectorAll("#room_wrapper tbody tr")
    );
    const sort = 10;
    const activePag = useRef(0);
    const [refreshKey, setRefreshKey] = useState(0);
    const [activeTab, setActiveTab] = useState(() => {
        const savedTab = localStorage.getItem(ACTIVE_TAB_STORAGE_KEY);
        return savedTab || 'All';
    });

    // Active data
    const chageData = (frist, sec) => {
        for (var i = 0; i < data.length; ++i) {
            if (i >= frist && i < sec) {
                data[i].classList.remove("d-none");
            } else {
                data[i].classList.add("d-none");
            }
        }
    };
    // use effect
    useEffect(() => {
        setData(document.querySelectorAll("#room_wrapper tbody tr"));
    }, []);

    const handleNotificationCancelled = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleTabSelect = (key) => {
        setActiveTab(key);
        localStorage.setItem(ACTIVE_TAB_STORAGE_KEY, key);
    };

    // Active pagginarion
    activePag.current === 0 && chageData(0, sort);
    return(
        <>
            <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
                <div className="card">
                    <div className="card-header">
                        <Nav variant="tabs">
                            <Nav.Item>
                                <Nav.Link eventKey="All">All Notifications</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="Scheduled">Scheduled</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                    <div className="card-body p-0">
                        <Tab.Content>
                            <Tab.Pane eventKey="All">
                              <AllNotification key={refreshKey} />
                            </Tab.Pane>
                            <Tab.Pane eventKey="Scheduled">
                              <ScheduledNotificationsList
                                onNotificationCancelled={handleNotificationCancelled}
                              />
                            </Tab.Pane>
                        </Tab.Content>
                    </div>
                </div>

            </Tab.Container>
        </>
    )
}
export default NotificationOverview;
